module.exports = __webpack_public_path__ + "static/media/tractorDayCab.9f4ca5e8.svg";